export const HOME_PAGE_HOTEL_CARD_WIDTH = '240px'

/**
 * SearchForm
 */
export const POPOVER_VERTICAL_OFFSET = 12
export const POPOVER_HORIZONTAL_OFFSET = 2
export const REDESIGN_SEARCH_BOX_EXPERIMENT = '5007b297-redesign-searchbox'
